// @flow
import React, { Component } from 'react';

type Props = {
  number: number,
  duration: number, // length of the animation in milliseconds
  suffix: string,
};

// AnimatedNumber displays a number and animates a counting up effect
export default class AnimatedNumber extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0,
    };
    this.animateNumber(props.duration, props.number);
  }

  animateNumber = (duration: number, target: number) => {
    let current = 0;
    const stepSize = target / duration;
    const timer = setInterval(() => {
      current += stepSize;
      this.setState({
        value: current.toFixed(2),
      });
    }, 1);

    // make sure the value
    setTimeout(() => {
      clearInterval(timer);
      this.setState({
        value: target,
      });
    }, duration);
  };

  render() {
    return <span>{this.state.value}{this.props.suffix}</span>;
  }
}
